import React, { Component, Children, cloneElement } from 'react';
import DocumentTitle from 'react-document-title';
import { scroller, animateScroll } from 'react-scroll';
import Intercom from 'react-intercom';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import StartupNavigation from './components/StartupNavigation';
import SubmitModal from './components/SubmitModal';

class App extends Component {
  state = {
    modalSubject: '',
    showModal: false
  }

  render() {
    const {
      modalSubject,
      showModal
    } = this.state;

    const {
      anchorTo,
      submitSuccess
    } = this;

    const children = Children.map(this.props.children, function(child) {
      return cloneElement(child, {
        showModal,
        anchorTo,
        submitSuccess
      });
    });

    const navProps = {
      anchorTo
    };

    let navigation = (<Navigation {...navProps} />);
    if (['/0-to-startup', '/startup-application'].includes(location.pathname)) {
      navigation = (<StartupNavigation {...navProps} />);
    }

    return (
        <DocumentTitle title='DesignCue'>
          <div>
            {navigation}
            <div className="main-body">
              {children}
            </div>
            <div className="off-blue-bg">
              <div className="container-fluid main-container">
                <div className="col-md-10 col-md-offset-1 col-sm-12">
                  <Footer />
                </div>
              </div>
            </div>
            <Intercom appID="bzpcs5yh" />
            <SubmitModal showModal={showModal} closeModal={this.closeModal} subject={modalSubject} />
          </div>
        </DocumentTitle>
    );
  }

  componentDidUpdate() {
    if (location.hash === '#how-it-works') {
      this.anchorTo('how-it-works', -800);
    }
    if (location.hash === '#designers') {
      this.anchorTo('designers', -800);
    }
  }

  anchorTo = (anchorName, offset) => {
    scroller.scrollTo(anchorName, {
      duration: 500,
      smooth: true,
      offset: typeof offset === 'number' ? offset : -100
    });
  }

  submitSuccess = (modalSubject) => {
    animateScroll.scrollToTop({
      duration: 500,
      delay: 100,
      smooth: true
    });
    this.setState({
      modalSubject,
      showModal: true
    });
  }

  closeModal = () => {
    this.setState({
      showModal: false
    });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js